export default __webpack_public_path__ + "static/media/arrow.30fae0c5.svg";